export default function IconCheck({ color = "white" }) {
  return (
    <svg width="16px" height="16px" viewBox="0 0 16 16" fill="none">
      <path
        d="M15.4141 4.91424L5.99991 14.3285L0.585693 8.91424L3.41412 6.08582L5.99991 8.6716L12.5857 2.08582L15.4141 4.91424Z"
        fill={color}
      />
    </svg>
  );
}
